import React, { FC } from 'react';
import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
  }),
);

interface Params {
  name: string;
  values: (string | null)[];
}

const DetailItemArray: FC<Params> = (props) => {
  const { name, values } = props;
  const classes = useStyles();

  return (
    <>
      <Grid item xs={12} sm={2} className={classes.left}>
        <Typography className={classes.label}>{name} :</Typography>
      </Grid>
      <Grid item xs={12} sm={10} className={classes.left}>
        {values?.map((valueItem) => (
          <Typography key={`value-key-${valueItem}`}>{valueItem}</Typography>
        ))}
      </Grid>
    </>
  );
};

export default DetailItemArray;
